// extracted by mini-css-extract-plugin
module.exports = {"container":"NoContentMessage_container__xW1d9","message":"NoContentMessage_message__Dguz8"};